import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { ActivatedRoute, Router } from '@angular/router';
 
@Component({
  selector: 'app-crown-setup',
  templateUrl: './crown-setup.component.html',
  styleUrls: ['./crown-setup.component.scss']
})
export class CrownSetupComponent implements OnInit {
  createCartonFlag = true;
  whiteListFlag = true
  pointConfigrationFlag = false
  targetFlag = false
  
  id : any = "";
  
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };

  config: NgWizardConfig = {
    selected: 0, //default selected value
    theme: THEME.arrows,
    toolbarSettings: {}
  };
  is_caplimt : any = "0";
  cartonId : any = "";

  campaignDetail : any = {}

  constructor(
    private ngWizardService: NgWizardService,
    private router : Router,
    private activatedRoute: ActivatedRoute) {
      this.cartonId =  this.activatedRoute.snapshot.paramMap.get("campaign_id")
      console.log(this.cartonId)
      
    }
 
  ngOnInit() {
    this.campaignDetail = JSON.parse(localStorage.getItem('crown_collection'))
    this.cartonSetps();
    
  }
  

  cartonSetps(){
    
    this.createCartonFlag = true;
      if(this.campaignDetail.create == 1){
        this.whiteListData(true)
        this.whiteListFlag = true
      }else{
        this.whiteListFlag = false
      }
      if(this.campaignDetail.whitelist == 1){
        this.pointConfigrationFlag = true
        this.pointConfigration(true)
      }else{
        this.pointConfigrationFlag = false
      }
      if(this.campaignDetail.points_config == 1){
        this.targetFlag = true
        this.target(true)
      }else{
        this.targetFlag = false
      }
      if(this.campaignDetail.target == 1){
        this.targetFlag = true
        this.target(true)
      }else{
        this.targetFlag = false
      }
    
  }
 
  createCartonData(e){
    // debugger
    console.log(e)
    this.whiteListFlag = e;
    if(this.whiteListFlag){
      setTimeout(()=>{
        this.ngWizardService.next();
      },500)
    }
  }
  whiteListData(event){
    console.log("@#$%",event)
    this.pointConfigrationFlag = event
    if(this.pointConfigrationFlag){
      setTimeout(()=>{
        this.ngWizardService.next();
      },100)
    }
  }
  pointConfigration(e){
    console.log(e)
    this.targetFlag = e
    if(this.targetFlag){
      setTimeout(()=>{
        this.ngWizardService.next();
      },100)
    }
  }
  target(e){
    setTimeout(()=>{
      this.ngWizardService.next();
    },100)

  }

  caplimit(e){
    // debugger
    console.log(e)
    this.is_caplimt = e;
  }
  campaignID(e){
    this.cartonId = e;
    console.log("campaignID",e)
  }
}
